import moment from "moment";
import momentTz from "moment-timezone";

export default {
    data() {
        return {
            masterServiceCategory: [
                { value: 1, label: 'Strength Training' },
                { value: 2, label: 'Weight Loss Training' },
                { value: 9, label: 'Personal Training' },
                { value: 10, label: 'Yoga Instructors' },
                { value: 11, label: 'Nutritionists' }
            ],
            currencySign: '$',
            baseUrl: process.env.MIX_APP_URL,
            siteUrl: 'https://api.asrodev.ir/',
            shopPanel: 'https://panel.asrodev.ir/',
            statuses: [
                {id: 1, 'name': 'active'},
                {id: 0, 'name': 'deActive'},
            ],
            defaults: [
                {id: 0, name: 'No'},
                {id: 1, name: 'YES'}
            ],
            routes: {
                who_we_are: `/who-we-are`,
                contact_us: '/contact-us',
                help: `/help`,
                terms_of_service: `/term-of-service`,
                privacy_policy: `/privacy-policy`,
                cookie_policy: `/privacy-policy`,
                blog: 'https://happytrainers.com/blog',
            },
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from;
        });
    },
    computed: {
        prevRoutePath() {
            return this.prevRoute ? this.prevRoute.path : '/'
        },
    },
    methods: {
        getHeldCourseCount(_courses) {
            if ( typeof _courses != 'object' ) return false;

            let count = 0;
            _courses.forEach( (value) => {
                if ( value.status == -3 ) count = count + 1;
            })
            if ( count == 0 ) return false;
            return count;
        },
        getMasterActiveClientsCount(_courses) {
            if ( typeof _courses != 'object' ) return false;

            let count = {};
            _courses.forEach( (value) => {
                if ( value.status == -3 ) {
                    count[value.user_id] = 'ok';
                }
            })
            count = Object.keys(count).length;
            if ( count == 0 ) return false;
            return count;
        },
        determineSpecialityFromUrl(_location) {
            let pathname = window.location.pathname,
                split = pathname.split("/"),
                speciality = split[1];
            
            let determineSpaciality = {
                'strength-trainers': 1,
                'personal-trainers': 9,
                'weight-loss-trainers': 2
            };
            if ( speciality in determineSpaciality ) 
                return determineSpaciality[speciality];
            else 
                return null;
        },
        certificate(_info) {
            let data = [];
            
            data = this.certificateSerialize(_info, 1);
            if ( !data.length ) {
                data = this.certificateSerialize(_info, 0);
            }
            return data;
        },
        certificateSerialize(_info, _default) {
            let data = [];
            _info.forEach( value => {
                if ( data.length <= 2 && value.key == 2 && value.default == _default ) {
                    data.push(value);
                }
            });
            return data;
        },
        getCurrentUserTz() {
            return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
        },
        isValidTimeZone(tz) {
            if (!Intl || !Intl.DateTimeFormat().resolvedOptions().timeZone) {
                throw new Error('Time zones are not available in this environment');
            }
        
            try {
                Intl.DateTimeFormat(undefined, {timeZone: tz});
                return true;
            }
            catch (ex) {
                return false;
            }
        },
        convertDateTime(_dateTime) {
            let date = '';
            date = new Date(`${_dateTime} UTC`);

            // In case its IOS, parse the fulldate parts and re-create the date object.
            if(Number.isNaN(date.getMonth())) {
                let arr = _dateTime.split(/[- :]/);
                date = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
                let UtcDate = new Date(`${date} UTC`);
                return UtcDate.toLocaleString('en-CA');
            }

            return date.toLocaleString('en-CA');
        },
        convertDateTimeToTimezone(_date, _timeZone) {
            if ( !this.isValidTimeZone(_timeZone) ) return 'timezone incorrect';
            let date = "";
            // In case its IOS, parse the fulldate parts and re-create the date object.
            // date = new momentTz(_date);
            _timeZone = _timeZone ?? 'UTC';
            date = momentTz.tz(_date, "YYYY-MM-DD hh:mm:ss", "UTC");
            return date.tz(_timeZone).format("YYYY-MM-DD HH:mm:ss");
            // // let tDate = date.tz(_timeZone, true);
            // // return date.clone().tz(_timeZone).format();
            // return new momentTz(_date).tz(_timeZone);
            // let UtcDate = new Date(`${tDate} UTC`);
            // return UtcDate.toLocaleString('en-US');
        },
        goTo(_href) {
            window.location.href = _href;
        },
        isClientSide() {
            return (typeof window !== "undefined");
        },
        getCurrentPatch() {
            return (typeof window !== "undefined") ? window.location.pathname : null;
        },
        replaceNumber: function (n) {
            if (n != undefined) {
                n = n.toString();
                const find = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
                const replace = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
                for (let i = 0; i < find.length; i++) {
                    n = n.replace(new RegExp(find[i], 'g'), replace[i]);
                }
                return n;
            }
        },
        diffforhumans(time) {
            var date = new Date((time || "").replace(/-/g, "/").replace(/[TZ]/g, " ")),
                diff = (((new Date()).getTime() - date.getTime()) / 1000),
                day_diff = Math.floor(diff / 86400);

            if (isNaN(day_diff) || day_diff < 0 || day_diff >= 31) return;

            return day_diff == 0 && (
                diff < 60 && " right now" || diff < 120 && " 1 minute ago" || diff < 3600 && Math.floor(diff / 60) + " Moments ago" || diff < 7200 && " 1 hour ago" || diff < 86400 && Math.floor(diff / 3600) + " Hours ago") || day_diff == 1 && " Yesterday" || day_diff < 7 && day_diff + " A few days ago" || day_diff < 31 && Math.ceil(day_diff / 7) + " last week ";
        },
        isMobile: function () {
            if (typeof window !== "undefined") {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            }

            return false
        },
        isNaN: function (value) {
            const n = Number(value);
            return n !== n;
        },
        evenNumber: function (number) {
            return number % 2 === 0
        },
        formatNumber(n, c, d, t) {
            var c = isNaN(c = Math.abs(c)) ? 2 : c,
                d = d === undefined ? '.' : d,
                t = t === undefined ? ',' : t,
                s = n < 0 ? '-' : '',
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
        },
        getStatus: function (status) {
            switch (status) {
                case 0:
                    return 'deActive';
                    break;
                case 1:
                    return ' active';
                    break;
                case 2:
                    return 'معلق';
                    break;
            }
        },
        statusColors(status) {
            switch (status) {
                case 0:
                    return 'bg-red-100 text-white-800';
                case 1:
                    return 'bg-green-100 text-green-800';
                case 2:
                    return 'bg-red-100 text-red-800';
            }
        },
        makeRandomColor() {
            const randomColor = Math.floor(Math.random() * 16777215).toString(16);
            return "#" + randomColor;
        },
        textShorter: function (text, length) {
            if (!text) return null;
            var string, replace;
            string = '';
            replace = text.replace(/<[^>]*>/g, "");
            if (length && replace.length > length) {
                if(replace.substr(length - 10, 20).search(/&.*;/)){
                    length = length + 20;
                }
                
                string += replace.substr(0, length);
                string += ' ...';
            } else {
                string += replace
            }

            return string;
        },

        inArray(needle, array) {
            let length = array.length;

            for (let i = 0; i < length; i++) {
                if (array[i] === needle) return true;
            }

            return false;
        },

        check_mobile_number(mobile) {
            if (isNaN(mobile)) {
                return true;
            } else {
                if (mobile.toString().trim().length == 11) {
                    if (mobile.toString().charAt(0) == '0' && mobile.toString().charAt(1) == '9') {
                        return false;
                    } else {
                        return true;
                    }
                } else if (mobile.toString().trim().length == 10) {
                    if (mobile.toString().charAt(0) == '9') {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
        },
        number_format: function (num) {
            num = num.toString();
            let format = '';
            let counter = 0;
            for (let i = num.length - 1; i >= 0; i--) {
                format += num[i];
                counter++;
                if (counter == 3 && num.length > 3) {
                    format += ",";
                    counter = 0;
                }
            }
            return format.split('').reverse().join('');
        },
        gregorian_to_jalali: function (gy, gm, gd) {
            var g_d_m, jy, jm, jd, gy2, days;
            g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
            if (gy > 1600) {
                jy = 979;
                gy -= 1600;
            } else {
                jy = 0;
                gy -= 621;
            }
            gy2 = (gm > 2) ? (gy + 1) : gy;
            days = (365 * gy) + (parseInt((gy2 + 3) / 4)) - (parseInt((gy2 + 99) / 100)) + (parseInt((gy2 + 399) / 400)) - 80 + gd + g_d_m[gm - 1];
            jy += 33 * (parseInt(days / 12053));
            days %= 12053;
            jy += 4 * (parseInt(days / 1461));
            days %= 1461;
            if (days > 365) {
                jy += parseInt((days - 1) / 365);
                days = (days - 1) % 365;
            }
            jm = (days < 186) ? 1 + parseInt(days / 31) : 7 + parseInt((days - 186) / 30);
            jd = 1 + ((days < 186) ? (days % 31) : ((days - 186) % 30));
            return [jy, jm, jd];
        },
        jalali_to_gregorian: function (jy, jm, jd) {
            var gy = (jy <= 979) ? 621 : 1600;
            jy -= (jy <= 979) ? 0 : 979;
            var days = (365 * jy) + ((parseInt(jy / 33)) * 8) + (parseInt(((jy % 33) + 3) / 4))
                + 78 + jd + ((jm < 7) ? (jm - 1) * 31 : ((jm - 7) * 30) + 186);
            gy += 400 * (parseInt(days / 146097));
            days %= 146097;
            if (days > 36524) {
                gy += 100 * (parseInt(--days / 36524));
                days %= 36524;
                if (days >= 365) days++;
            }
            gy += 4 * (parseInt((days) / 1461));
            days %= 1461;
            gy += parseInt((days - 1) / 365);
            if (days > 365) days = (days - 1) % 365;
            var gd = days + 1;
            var sal_a = [0, 31, ((gy % 4 == 0 && gy % 100 != 0) || (gy % 400 == 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var gm
            for (gm = 0; gm < 13; gm++) {
                var v = sal_a[gm];
                if (gd <= v) break;
                gd -= v;
            }
            return [gy, gm, gd];
        },
        show_mobile_box: function () {
            this.$nextTick(function () {
                $('body').css('overflow-y', 'hidden');
                const width = $(window).width();
                const right = "-" + width + "px";
                $('.mobile_data_box').css({'right': right});
                setTimeout(function () {
                    $('.mobile_data_box').css('right', '0px');
                }, 50);
            });
        },
        setRangSlider: function (price) {
            const app = this;
            var slider = document.querySelector('.price_rang_slider');
            if (this.noUiSlider == null) {
                if (parseInt(price) > 0) {
                    this.noUiSlider = noUiSlider.create(slider, {
                        start: [0, price],
                        connect: true,
                        direction: 'rtl',
                        range: {
                            'min': 0,
                            'max': price
                        },
                        format: {
                            from: function (value) {
                                return parseInt(value);
                            },
                            to: function (value) {
                                return parseInt(value);
                            },
                        }
                    });
                }
            }

            if (slider.noUiSlider != undefined) {
                slider.noUiSlider.on('update', function (values, handle) {
                    app.min_price = values[0];
                    app.max_price = values[1];
                    $("#min_price").text(app.replaceNumber(app.number_format(values[0])));
                    $("#max_price").text(app.replaceNumber(app.number_format(values[1])));
                });

                let search = new window.URLSearchParams(window.location.search);
                const min = search.get('price[min]') != null ? parseInt(search.get('price[min]')) : 0;
                if (search.get('price[max]') != null) {
                    slider.noUiSlider.updateOptions({
                        start: [min, parseInt(search.get('price[max]'))]
                    })
                }

                if (search.get('price[min]') != null && search.get('price[max]') == null) {
                    slider.noUiSlider.updateOptions({
                        start: [parseInt(search.get('price[min]')), slider.noUiSlider.get()[1]]
                    })
                }
            }
        },
        getParam(value) {
            let search = new window.URLSearchParams(window.location.search);
            return search.get(value)
        },
        add_filter: function (id, role, array) {
            if ($("#" + role + "-" + id + "").hasClass('active')) {
                $("#" + role + "-" + id + "").removeClass('active');
                this.remove_url_query_string(role, id);
            } else {
                $("#" + role + "-" + id + "").addClass('active');
                if (array == true) {
                    this.add_url_query_string(role, id);
                } else {
                    this.add_url_param_single(role, id);
                }

            }
        },
        add_url_query_string: function (key, value) {
            let url = window.location.href;
            let check = url.split(key);
            const n = check.length - 1;
            const url_params = url.split('?');
            if (url_params[1] == undefined) {
                url = url + "?" + key + "=" + value;
            } else {
                url = url + "&" + key + "=" + value;
            }
            this.changed_url(url);
        },
        add_url_param_single: function (key, value, repet) {
            let params = new window.URLSearchParams(window.location.search);
            let url = window.location.href;
            if (params.get(key) != null) {
                let old_param = key + "=" + encodeURIComponent(params.get(key));
                let new_param = key + "=" + value;
                url = url.replace(old_param, new_param);
            } else {
                const url_params = url.split('?');
                if (url_params[1] == undefined) {
                    url = url + "?" + key + "=" + value;
                } else {
                    url = url + "&" + key + "=" + value;
                }
            }
            this.changed_url(url);
        },
        check_params: function () {
            let url = window.location.href;
            const params = url.split('?');
            if (params[1] != undefined) {
                if (params[1].indexOf('&') > -1) {
                    let vars = params[1].split('&');
                    for (let i in vars) {
                        let k = vars[i].split('=')[0];
                        let v = vars[i].split('=')[1];
                        let d = k.split('[');

                        if (d[1] != undefined) {
                            $("#" + d[0] + '-' + v + "").addClass('active');
                        } else {
                            $("#" + k + '-' + v + "").addClass('active');
                        }
                        this.add_filter_tag();
                    }
                } else {
                    let t = params[1];
                    let k = t.split('=')[0];
                    let v = t.split('=')[1];
                    let d = k.split('[');

                    if (d[1] != undefined) {
                        $("#" + d[0] + '-' + v + "").addClass('active');
                    } else {
                        $("#" + k + '-' + v + "").addClass('active');
                    }
                    this.add_filter_tag();
                }
            }
        },
        add_filter_tag: function () {

        },

        get_request_url: function (url, page) {
            const url_params = url.split('?');
            if (url_params[1] == undefined) {
                url = url + "?page=" + page;
            } else {
                url = url + "&page=" + page;
            }
            return url
        },
        check_has_off: function (product) {
            if (product.get_first_product_price != null) {
                const last_time = product.get_first_product_price.offers_last_time;
                const time = Math.floor(Date.now() / 1000);
                if (product.get_first_product_price.offers == 1 && (last_time - time) > 0) {
                    return (last_time - time);
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getDiscountValue: function (price1, price2) {
            let a = (price2 / price1) * 100;
            a = 100 - a;
            a = Math.round(a);
            return a;
        },
        get_offer: function (amount, offer) {
            let a = amount * ((100 - offer) / 100);
            // console.log(amount);
            // console.log(offer);
            // console.log(a);
            return a;
        },
        set_filter_event: function (el, page_url) {
            let data = $(el).attr('data');
            data = data.split('_');
            if ($('.check_box', el).hasClass('active')) {
                $('.check_box', el).removeClass('active');
                this.remove_url_query_string(data[0], data[2], page_url);
                this.remove_filter_tag(data[0], data[2], page_url);
            } else {
                $('.check_box', el).addClass('active');
                this.add_url_query_string(data[0], data[2], page_url);
                this.add_filter_tag(data, data[0], data[2], page_url);
            }
        },
        setPageUrl: function (url) {
            window.history.pushState('data', 'title', url);
        },
        remove_url_query_string: function (key, value, page_url) {
            let url = page_url == undefined ? window.location.href : page_url;
            let check = url.split(key);
            const params = url.split('?');
            let h = 0;
            if (params[1] != undefined) {
                if (params[1].indexOf('&') > -1) {
                    let vars = params[1].split('&');
                    for (let i in vars) {
                        let k = vars[i].split('=')[0];
                        let v = vars[i].split('=')[1];
                        let n = k.indexOf(key);
                        if (n > -1 && v != value) {
                            k = k.replace(key, '');
                            k = k.replace('[', '');
                            k = k.replace(']', '');
                            const new_string = key + "[" + h + "]=" + v;
                            const old_string = key + "[" + k + "]=" + v;
                            url = url.replace(old_string, new_string);
                            h++;
                        } else if (n > -1) {
                            url = url.replace('&' + k + "=" + v, '');
                            url = url.replace('?' + k + "=" + v, '');
                        }
                    }
                } else {
                    url = url.replace('?' + key + "[0]" + "=" + value, '');
                }
            }

            const url_params = url.split('?');
            if (url_params[1] == undefined) {
                url = url.replace('&', '?');
            }
            this.changed_url(url);
        },
        check_search_params: function (page_url) {
            let url = page_url == undefined ? window.location.href : page_url;
            const params = url.split('?');
            if (params[1] != undefined) {
                if (params[1].indexOf('&') > -1) {
                    let vars = params[1].split('&');
                    for (let i in vars) {
                        let k = vars[i].split('=')[0];
                        let v = vars[i].split('=')[1];
                        k = k.split('[');
                        this.add_active_filter(k, v);
                    }
                } else {
                    let k = params[1].split('=')[0];
                    let v = params[1].split('=')[1];
                    k = k.split('[');
                    this.add_active_filter(k, v);
                }
            }
        },
        add_active_filter: function (k, v) {
            if (k.length > 1) {
                let data = "";
                let filter_key = k[0];
                if (k.length == 3) {
                    data = k[0] + "[" + k[1] + "_param_" + v;
                    data = "'" + data + "'";
                    filter_key = k[0] + "[" + k[1];
                } else {
                    data = k[0] + "_param_" + v;
                }
                $('li[data=' + data + '] .check_box').addClass('active');
                $('li[data=' + data + ']').parent().parent().slideDown();
                if ($('li[data=' + data + ']').parent().parent().parent().parent().find('.title_box').find('span').hasClass('fa-plus-circle')) {
                    $('li[data=' + data + ']').parent().parent().parent().parent().find('.title_box').find('span').removeClass('fa-plus-circle').addClass('fa-minus-circle')
                }
                if ($('li[data=' + data + ']').length == 1) {
                    this.add_filter_tag(data, filter_key, v);
                }
            } else {
                if (k == "has_product") {
                    this.set_enable_product_status_toggle();
                } else if (k == "has_ready_to_shipment") {
                    this.set_enable_send_status_toggle();
                }
            }
        },
        remove_all_filter: function (page_url) {
            let url = page_url == undefined ? window.location.href : page_url;
            url = url.split('?')[0];
            $('.selected_filter_item').remove();
            $("#filter_div").hide();
            $('.filter_box .list-inline li').find('.check_box').removeClass('active');
            if ($('#product_status .toggle-slide .toggle-off').hasClass('active')) {
                $("#product_status").click();
            }
            if ($('#send_status .toggle-slide .toggle-off').hasClass('active')) {
                $("#send_status").click();
            }
            if (this.noUiSlider) {
                this.noUiSlider.reset();
            }
            if (page_url == undefined) {
                this.setPageUrl(url);
                this.getProduct(1);
            } else {
                this.search_url = url;
            }
        },
        remove_url_params: function (key, value, page_url) {
            let params = new window.URLSearchParams(window.location.search);
            if (page_url != undefined) {
                let search_url_params = this.search_url.split('?');
                if (search_url_params[1] != undefined) {
                    search_url_params = '?' + search_url_params[1];
                    params = new window.URLSearchParams(search_url_params);
                }
            }
            let url = page_url == undefined ? window.location.href : page_url;
            if (params.get(key) != null) {
                value = encodeURIComponent(value);
                url = url.replace('&' + key + "=" + value, '');
                url = url.replace('?' + key + "=" + value, '');
                this.remove_filter_tag(key, value);

                const url_params = url.split('?');
                if (url_params[1] == undefined) {
                    url = url.replace('&', '?');
                }

                if (page_url == undefined) {
                    this.changed_url(url);
                } else {
                    this.search_url = url;
                }
            }
        },
        getWidth: function (key, key2) {
            key2 = key2 + 1;
            const a = "score" + key2;
            if (this.list.data[key]['get_score'][a] != undefined) {
                return (this.list.data[key]['get_score'][a] * 25);
            } else {
                return 50;
            }
        },
        getDate: function (time) {
            time = time * 1000;
            const date = new Date(time);
            const jalali = this.gregorian_to_jalali(date.getFullYear(), (date.getMonth() + 1), date.getDate());
            const r = this.replaceNumber(jalali[2]) + " " + this.monthName[(jalali[1] - 1)] + " " + this.replaceNumber(jalali[0]);
            return r;
        },
    }
}
